/**
 * DevExtreme (esm/__internal/viz/components/consts.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export default {
  events: {
    mouseover: "mouseover",
    mouseout: "mouseout",
    mousemove: "mousemove",
    touchstart: "touchstart",
    touchmove: "touchmove",
    touchend: "touchend",
    mousedown: "mousedown",
    mouseup: "mouseup",
    click: "click",
    selectSeries: "selectseries",
    deselectSeries: "deselectseries",
    selectPoint: "selectpoint",
    deselectPoint: "deselectpoint",
    showPointTooltip: "showpointtooltip",
    hidePointTooltip: "hidepointtooltip"
  },
  states: {
    hover: "hover",
    normal: "normal",
    selection: "selection",
    normalMark: 0,
    hoverMark: 1,
    selectedMark: 2,
    applyHover: "applyHover",
    applySelected: "applySelected",
    resetItem: "resetItem"
  },
  radialLabelIndent: 30,
  pieLabelSpacing: 10,
  pieSeriesSpacing: 4
};